import { Component, inject, OnInit } from '@angular/core';
import { TherapistStateService } from '@therapist/shared/services/state/therapist-state.service';
import { ClientSearchFieldComponent } from '../client-search-field/client-search-field.component';
import { ClientListComponent } from '../client-list/client-list.component';
import { TherapistClientStateService } from '@therapist/shared/services/state/therapist-client-state.service';
import { Router } from '@angular/router';
import { NgClass } from '@angular/common';
import { WithMobileDetection } from '@base/mixins/with-mobile-detection.mixin';

@Component({
  selector: 'sana-tp-home-page',
  imports: [
    ClientSearchFieldComponent,
    ClientListComponent,
    NgClass
  ],
  templateUrl: './home-page.component.html',
  styleUrl: './home-page.component.scss'
})
export class HomePageComponent extends WithMobileDetection()
  implements OnInit {

  readonly #therapistStateService = inject(TherapistStateService);
  readonly #clientStateService = inject(TherapistClientStateService);
  readonly #router = inject(Router);

  readonly therapist = this.#therapistStateService.getCurrentTherapist();

  ngOnInit() {
    this.#clientStateService.loadClientList();
  }

  cardClicked() {
    console.log('card clicked');
  }

  addClient() {
    this.#router.navigate(['/client/add']);
  }
}
